import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Logo({ size = "md", to, className = "" }) {
  const { user } = useAuth();
  const dest = to !== undefined ? to : (user ? "/dashboard" : "/");
  const sizes = {
    sm: { mark: "h-7 w-7 text-[13px]", text: "text-base" },
    md: { mark: "h-9 w-9 text-[15px]", text: "text-lg" },
    lg: { mark: "h-12 w-12 text-[18px]", text: "text-2xl" },
  };
  const s = sizes[size] || sizes.md;

  return (
    <Link
      to={dest}
      data-testid="logo-link"
      className={`group inline-flex items-center gap-2.5 ${className}`}
    >
      <span
        className={`relative grid place-items-center rounded-[10px] bg-gradient-gold font-display font-semibold text-[#080B14] ${s.mark} glow-gold-soft transition-transform group-hover:scale-[1.04]`}
      >
        B
        <span className="absolute inset-0 rounded-[10px] ring-1 ring-white/20" />
      </span>
      <span className={`font-display font-medium tracking-tight ${s.text}`}>
        Bora Moyo
      </span>
    </Link>
  );
}
